import { useQuery } from '@tanstack/react-query';
import axiosInstance from '@/dataProvider/axios';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import {
  ORG_USAGE_TIMESERIES_ENDPOINT,
  ORG_USAGE_TIMESERIES_MONTH_ENDPOINT,
} from '@/services/org-admin';
import type { OrgUsageTimeseries } from '@/services/org-admin';
import { isMonthSelection, type UsageWindowSelection } from './useOrgUsageReport';

// Admin-only upstream (403 for a plain member) — callers must pass `enabled: false`
// for non-admins rather than relying on this hook to know the caller's role.
export function useOrgUsageTimeseries(
  selection: UsageWindowSelection,
  options?: { enabled?: boolean },
) {
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useQuery({
    queryKey: ['org-usage-timeseries', orgId, selection],
    queryFn: async () => {
      const url = isMonthSelection(selection)
        ? ORG_USAGE_TIMESERIES_MONTH_ENDPOINT(orgId!, selection)
        : ORG_USAGE_TIMESERIES_ENDPOINT(orgId!, selection);
      const { data } = await axiosInstance.get<OrgUsageTimeseries>(url);
      return data;
    },
    enabled: !!orgId && (options?.enabled ?? true),
    refetchOnMount: 'always',
  });
}
